import React from 'react'
import { Box, MenuItem, Tab, Tabs, TextField, Typography } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import useIsMobile from '../hooks/useIsMobile'

const DocumentCategories = ({ documentCategoryDropdown, tab, setTab }) => {
  const isMobile = useIsMobile()

  if (!documentCategoryDropdown) return null

  if (isMobile)
    return (
      <TextField
        select
        label='Categories'
        value={tab}
        onChange={(e) => setTab(e.target.value)}
      >
        <MenuItem value={0}>Uncategorized</MenuItem>
        {documentCategoryDropdown.options.map((o, i) => {
          return (
            <MenuItem value={i + 1} key={o.id}>
              {o.name}
            </MenuItem>
          )
        })}
      </TextField>
    )

  return (
    <Box sx={{ mr: 2 }}>
      <Typography sx={{ mt: 2 }}>Categories</Typography>

      <Tabs
        orientation='vertical'
        sx={{
          mt: 1,
          flexShrink: 0,
          maxHeight: '400px',
          backgroundColor: 'white',
          border: `1px solid ${grey[300]}`,
          maxWidth: '200px',
          minWidth: '200px',
          flexShrink: 0,
        }}
        value={tab}
        onChange={(_e, val) => setTab(val)}
        variant='scrollable'
      >
        <Tab
          sx={{
            alignItems: 'start',
            backgroundColor: tab === 0 ? blue[50] : null,
            fontWeight: tab === 0 ? 'bold' : null,
          }}
          label={'Uncategorized'}
        ></Tab>
        {documentCategoryDropdown &&
          documentCategoryDropdown.options.map((o, i) => {
            return (
              <Tab
                sx={{
                  alignItems: 'start',
                  borderTop: `1px solid ${grey[200]}`,
                  backgroundColor: tab === i + 1 ? blue[50] : null,
                  fontWeight: tab === i + 1 ? 'bold' : null,
                }}
                key={o.id}
                label={o.name}
              ></Tab>
            )
          })}
      </Tabs>
    </Box>
  )
}

export default DocumentCategories
